import { CellClickEventArgs } from '@syncfusion/ej2-react-schedule';

export const onAddingEvent = (args?: CellClickEventArgs, scheduleObj?: any) => {
  let props;
  if (!args) {
    props = {
      startTime: new Date(),
      endTime: new Date(new Date().setHours(new Date().getHours() + 1)),
      isAllDay: true,
    };
  } else {
    props = args;
  }

  scheduleObj?.current?.openEditor(props, 'Add');
};

export interface ResetStateSetters {
  setProjectIds: (value: string[]) => void;
  setEventTitle: (value: string) => void;
  setEventDescription: (value: string) => void;
  setEventType: (value: string) => void;
  setSelectedFacilitatorsIds: (value: string[]) => void;
  setIsEditingSeriesWithExceptions: (value: boolean) => void;
}

export const resetState = (setters: ResetStateSetters) => {
  const {
    setProjectIds,
    setEventTitle,
    setEventDescription,
    setEventType,
    setSelectedFacilitatorsIds,
    setIsEditingSeriesWithExceptions,
  } = setters;

  setProjectIds([]);
  setEventTitle('');
  setEventDescription('');
  setEventType('');
  setSelectedFacilitatorsIds([]);
  setIsEditingSeriesWithExceptions(false);
};
